import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import type { iAccountAuditLog } from "./account-audit-log-model";

export class AccountAuditLogsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.accountAuditLogs.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.accountAuditLogs = new EntityServices<iAccountAuditLog>(
      SDKConfig,
      "account-audit-logs",
      {}
    );
    this.accountAuditLogs.configure(config);
  }

  accountAuditLogs: EntityServices<iAccountAuditLog>;
}

export const accountAuditLogsServices = new AccountAuditLogsServices(
  SDKConfig
);
